export default "__VITE_ASSET__9c7C2ozM__"